module.exports = __webpack_public_path__ + "static/media/20170830_132133.24cf82f4.jpg";